import type { Breadcrumb } from "components/Breadcrumb/Breadcrumb";
import type { FC, ReactNode } from "react";
import { createContext, useContext, useState } from "react";

type IBreadcrumbContext = {
  breadcrumbItems: Breadcrumb[];
  setBreadcrumbItems: (items: Breadcrumb[]) => void;
};

export const BreadcrumbContext = createContext<IBreadcrumbContext>({
  breadcrumbItems: [],
  setBreadcrumbItems: () => {
    // do nothings
  },
});

type BreadcrumbContextProviderProps = {
  children: ReactNode;
};

export const BreadcrumbContextProvider: FC<BreadcrumbContextProviderProps> = ({
  children,
}) => {
  const [items, setItems] = useState<Breadcrumb[]>([]);

  const setBreadcrumbItems = (items: Breadcrumb[]) => {
    setItems(items);
  };
  return (
    <BreadcrumbContext.Provider
      value={{ breadcrumbItems: items, setBreadcrumbItems }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
